// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetObjectsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetObjectsQuery = {
  customObjectDefinitions: { customObjectDefinitions?: Array<ObjectFragment | null> | null };
};

export type ObjectFragment = {
  customResourcePermissions?: {
    [index: string]: { [key in Types.PermissionAction]: Types.VerificationDecisionModel };
  } | null;
  name?: string | null;
  external?: boolean | null;
  description?: string | null;
  permissions?:
    | { [name in Types.PermissionName]: { [action in Types.PermissionAction]: Types.VerificationDecisionModel } }
    | null;
  uid: string;
  fields?: Array<ObjectFieldFragment | null> | null;
};

export type ObjectFieldFragment = {
  dataType?: Types.CustomFieldDefinitionDataTypeModel | null;
  helperText?: string | null;
  name?: string | null;
  code?: string | null;
  uid: string;
  status?: Types.StatusModel | null;
  parentEntityType?: Types.CustomFieldDefinitionEntityTypeModel | null;
  values?: Array<{ value?: string | null; label?: string | null; code?: string | null } | null> | null;
  parentCustomObjectDefinition?: { uid: string; name?: string | null } | null;
  customObjectDefinition?: { name?: string | null } | null;
};

export const ObjectFieldFragmentDoc = gql`
    fragment ObjectField on CustomFieldDefinitionModel {
  dataType
  helperText
  name
  code
  uid
  values(query: {limit: 10}) {
    value
    label
    code
  }
  status
  parentEntityType
  parentCustomObjectDefinition {
    uid
    name
  }
  customObjectDefinition {
    name
  }
}
    ` as unknown as DocumentNode<ObjectFieldFragment, unknown>;
export const ObjectFragmentDoc = gql`
    fragment Object on CustomObjectDefinitionModel {
  customResourcePermissions
  name
  external
  description
  permissions
  fields {
    ...ObjectField
  }
  uid
}
    ${ObjectFieldFragmentDoc}` as unknown as DocumentNode<ObjectFragment, unknown>;
export const GetObjectsDocument = gql`
    query GetObjects {
  customObjectDefinitions(query: {financialObject: false}) {
    customObjectDefinitions {
      ...Object
    }
  }
}
    ${ObjectFragmentDoc}` as unknown as DocumentNode<GetObjectsQuery, GetObjectsQueryVariables>;
